/**
 * Zone Detail Tabs Configuration
 */

import { Server, HardDrive, Monitor } from 'lucide-react'
import ZoneHosts from './ZoneHosts'
import ZoneDatastores from './ZoneDatastores'
import ZoneInstances from './ZoneInstances'
import type { ZoneCapacity } from '../../../types'

export const tabs = (_zone: ZoneCapacity | undefined) => [
    {
        label: 'Hosts',
        value: 'hosts',
        startIcon: <Server className="text-primary w-4 h-4" />,
        component: <ZoneHosts />,
    },
    {
        label: 'Datastores',
        value: 'datastores',
        startIcon: <HardDrive className="text-primary w-4 h-4" />,
        component: <ZoneDatastores />,
    },
    {
        label: 'Instances',
        value: 'instances',
        startIcon: <Monitor className="text-primary w-4 h-4" />,
        component: <ZoneInstances />,
    },
]
